import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Holiday {
  title: string;
  date: string;
  status: "holiday";
}

export type CalendarDepartmentScope = "band" | "school" | "org";

export interface HolidaysResponse {
  success: boolean;
  count: number;
  data: Holiday[];
  scope?: CalendarDepartmentScope | null;
  message?: string;
}

const fetchHolidays = async (
  year: number,
  scope?: CalendarDepartmentScope
): Promise<HolidaysResponse> =>
  (
    await customAxios.get<HolidaysResponse>(`/attendance/holidays`, {
      params: { year, ...(scope ? { scope } : {}) },
    })
  ).data;

export const useGetCalendarRecord = (
  year: number,
  scope?: CalendarDepartmentScope
) =>
  useQuery<HolidaysResponse, AxiosError>(
    ["holidays", year, scope ?? "auto"],
    () => fetchHolidays(year, scope),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Holidays",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load holidays",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
